import React from 'react';
import {getPaidColor} from '../utils/getPaidColor';
import PopupEditPaid from '../../OrdersPage/components/PopupEditPaid';

export function OrderPaidColumnFormatter(cellContent) {
  const paidValue = cellContent.paid ? parseFloat(cellContent.paid) : 0;
  const totalPaymentValue = cellContent.totalPayment ? parseFloat(cellContent.totalPayment) : 0;
  const paidPart = paidValue / totalPaymentValue;

  return (
    <div
         className="text-dark-75 font-weight-bolder d-flex align-items-center font-size-h5 text-nowrap"
    >
      <PopupEditPaid orderID={cellContent.orderNumber} paid={paidValue}/>
      <div className={'pr-2'} style={{color: getPaidColor(paidPart)}}>
        {paidValue ? (paidValue).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''}
      </div>
    </div>
  );
}
